"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFilterWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
exports.StyledFilterWrapper = (0, styled_1.default)('div') `
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: center;
`;
//# sourceMappingURL=FiltersContainer.styles.js.map